import SvgArrow from '@img/icons/arrow-up.svg';
import * as React from 'react';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Controls.styles';
const Controls = React.forwardRef((props, ref) => {
    const carousel = useCarouselContext();
    const activeIndex = props.activeIndex ? props.activeIndex : carousel.activeIndex;
    const maxIndex = props.maxIndex ? props.maxIndex : carousel.maxIndex;
    if (maxIndex === 0) {
        return null;
    }
    return (React.createElement(S.Container, { ref: ref, className: props.className },
        React.createElement(S.Button, { "aria-label": "Previous", disabled: !props.wrap && activeIndex === 0, onClick: (event) => {
                event.preventDefault();
                if (props.onClickPrev) {
                    props.onClickPrev();
                }
                else {
                    carousel.goToPrev(props.wrap);
                }
            } },
            React.createElement(SvgArrow, null)),
        React.createElement(S.Button, { "aria-label": "Next", disabled: !props.wrap && activeIndex === maxIndex, onClick: (event) => {
                event.preventDefault();
                if (props.onClickNext) {
                    props.onClickNext();
                }
                else {
                    carousel.goToNext(props.wrap);
                }
            } },
            React.createElement(SvgArrow, null))));
});
Controls.displayName = 'Controls';
export default Controls;
